/**
 * @generated SignedSource<<72f8e8543888706108f2b7cfb0105fb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunNovaAgentDryRunInput = {
  id: string;
  taskId: string;
  message?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RunNovaAgentDryRunMutation$variables = {
  input: RunNovaAgentDryRunInput;
};
export type RunNovaAgentDryRunMutation$data = {
  readonly runNovaAgentDryRun: {
    readonly result: {
      readonly output: string | null;
      readonly ranAt: string | null;
    } | null;
  } | null;
};
export type RunNovaAgentDryRunMutation = {
  variables: RunNovaAgentDryRunMutation$variables;
  response: RunNovaAgentDryRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RunNovaAgentDryRunPayload",
    "kind": "LinkedField",
    "name": "runNovaAgentDryRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaDryRunResult",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "output",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ranAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RunNovaAgentDryRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RunNovaAgentDryRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7770e33482002033009030c27d9a6895",
    "id": null,
    "metadata": {},
    "name": "RunNovaAgentDryRunMutation",
    "operationKind": "mutation",
    "text": "mutation RunNovaAgentDryRunMutation(\n  $input: RunNovaAgentDryRunInput!\n) {\n  runNovaAgentDryRun(input: $input) {\n    result {\n      output\n      ranAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea55eb82748decf6d422d3f6b74a22a6";

export default node;
